module.exports = __webpack_public_path__ + "media/pokemon2.4aca2954.webm";